import script from "./UpdateIllustrationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateIllustrationView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__